export default <T extends { preventDefault: () => void }>(
  callback: (event: T) => any,
  filter: (event: T) => any,
) => (event: T) => filter(event) ? callback(event) : undefined;